import React from "react";
import { motion } from "framer-motion";
import { prettierTitle } from "../utils";

const fontSizeHash = {
  1: "1.5rem",
  2: "1.25rem",
  3: "1rem",
};

const Heading = ({
  infoObjectName,
  path,
  name,
  data,
  options: { hideKeys: optionsHideKeys },
  rendererOptions: { hideKeys, level = 2 },
}) => {
  const HeadingTag = `h${level}`;

  const headingStyle = {
    margin: "0 0 0.25em 0",
    padding: "0",
    lineHeight: "1",
    fontSize: fontSizeHash[level],
  };

  return (
    <motion.div
      // initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      data-renderer="heading"
    >
      <HeadingTag style={headingStyle}>
        {prettierTitle(String(data || name))}
      </HeadingTag>
    </motion.div>
  );
};

export default Heading;
